import { render, staticRenderFns } from "./sidebarRightSide.vue?vue&type=template&id=c06e6f38&scoped=true&"
import script from "./sidebarRightSide.vue?vue&type=script&lang=js&"
export * from "./sidebarRightSide.vue?vue&type=script&lang=js&"
import style0 from "./sidebarRightSide.vue?vue&type=style&index=0&id=c06e6f38&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c06e6f38",
  null
  
)

export default component.exports